import React, { useRef } from "react";
import Papa from 'papaparse';
import Button from '@material-ui/core/Button';
import "tabulator-tables/dist/css/tabulator.min.css";
import LibraryAddIcon from '@material-ui/icons/LibraryAdd';


const CsvParseButton = ({ changeTableData }) => {
    const importFileRef = useRef(null);

    const parse = () => {
        const fields = ['fName', 'lName', 'phone', 'email'];
        const file = importFileRef.current?.files[0];
        if (file) {
            Papa.parse(file, {
                header: true,
                skipEmptyLines: true,
                transformHeader: (header, index) => {
                    if (index < fields.length) {
                        return fields[index];
                    }
                    return header; // Use the original header for any columns beyond your predefined fields.
                },
                complete: (results) => {
                    console.log(results);
                    changeTableData(results.data);
                }
            });
        }
    };
    

    const uploadFileClick = () => importFileRef.current?.click();

    return (
        <div>
            <input
                type="file"
                ref={importFileRef}
                accept='.xlsx, .xls, .csv'
                onChange={parse}
                style={{ display: 'none' }}
            />
            <div>
                <Button style={{ color: "#03a9f4" }} onClick={uploadFileClick}>
                    <LibraryAddIcon />
                </Button>
            </div>
        </div>
    );
}

export default CsvParseButton;
